import { csvCell, csvReasonList } from './csvCell';
import type { FlaggedRdStockRow } from './types';

const CSV_HEADERS = [
  'File',
  'Sheet',
  'Row',
  'Company',
  'Division',
  'Product',
  'Stock Location',
  'Item Master Location',
  'DC',
  'Correspondence',
  'Reasons',
] as const;

/** Spreadsheet of STOCK_V rows (mapped or unmatched) for the action email. */
export function rdStockRowsToCsv(rows: readonly FlaggedRdStockRow[]): string {
  const lines = [CSV_HEADERS.join(',')];
  for (const row of rows) {
    lines.push(
      [
        row.fileName,
        row.sheetName,
        String(row.sheetRow),
        row.company,
        row.division,
        row.productNumber,
        row.stockLocation,
        row.itemMasterLocation,
        row.dc,
        row.correspondence,
        csvReasonList(row.reasons),
      ]
        .map(csvCell)
        .join(','),
    );
  }
  return `${lines.join('\n')}\n`;
}
